export const setList = (state, payload) => state.list = payload

export const setItem = (state, payload) => {
  state.item = { ...state.item, ...payload}
}

export const addMemo = (state, payload) => {
  state.item.contact_memos.push(payload);
}

export const deleteMultipleMemo = (state, payload) => {
  state.item.contact_memos = state.item.contact_memos.filter(function (memo) {
    return !payload.ids.includes(memo.id);
  });
}
